<template>
  <el-table
    v-loading="$store.state.isLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
    ref="multipleTable"
    :data="tabList"
    :height="height"
    :row-class-name="tableRowClassName"
    @selection-change="handleSelectionChange"
    border
    style="width: 100%">
    <el-table-column
        type="selection"
        width="55">
    </el-table-column>
    <el-table-column v-for="(item,index) in columns"
     :sortable="item.sortable"
     :prop="item.field"
     :label="item.title"
     :width="item.width"
     :formatter="item.formatter"
     >
   </el-table-column>
  </el-table>

</template>

<script>
  export default {
    props:{
      tabList:Array,
      columns:Array,
      selectedList:Array,//已选数组
      tabHeight:String
    },
    data() {
      return {
        height:500,
        multipleSelectionAll: [],   // 所有选中的数据包含跨页数据
        multipleSelection: [],   // 当前页选中的数据
      }
    },
    created(){
    },
    watch:{
      selectedList:function(newVal,oldVal){
        this.tabList.forEach((item,index)=>{
          let isTrue = newVal.find(v=>v.selectId===item.selectId);
          if(isTrue){
            this.$refs.multipleTable.toggleRowSelection(item,true);
          }
        });
      },
      tabList:function(val){
        console.log(val);

      }
    },
    updated:function(){
      if(this.tabHeight){
        this.height = this.tabHeight;
      }else{
        this.height = this.$myfn.resetRigthSize();
      }
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        if(row.maintainStatus === 'X'){
          return "del-row";
        }else{
          return '';
        }
      },
      //取消选择
      cancelSelect(){
        this.tabList.forEach((item,index)=>{
          let isTrue = this.selectedList.find(v=>v.selectId===item.selectId);
          if(isTrue){
            this.$refs.multipleTable.toggleRowSelection(item,true);
          }else{
            this.$refs.multipleTable.toggleRowSelection(item,false);
          }
        });
      },
      //选中
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.$emit('getSelect',val);
      },
      handleClick(row) {
        //console.log(row);
      },
      //翻页时记录所选
      changePageCoreRecordData(){
        if(this.multipleSelectionAll.length){
          /* this.multipleSelectionAll.forEach((item)=>{
          }); */
          //获取当前页选中的ID

          //获取当前页没有选中的数据

        }else{
          this.multipleSelectionAll = this.multipleSelection;
        }
      }
    }
  }
</script>
